import { defineComponent as _defineComponent } from 'vue'
import {
  ApprovalChangeShift,
  ApprovalPreShift,
  ApprovalShift,
  ApprovalVacationUser
} from "@/models/approval/ApprovalResponse";
import { EnumWorkClassification } from "@/models/enum/Enum";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "../table/ApprovalChip.vue";
import TimeList from "@/components/list/TimeList.vue";
import { VacationFlowDat } from "@/models/transaction/VacationFlowDat";

type Props = {
  dat: VacationFlowDat;
  approvals: ApprovalVacationUser[];
  shift: ApprovalShift;
  shiftPre: ApprovalPreShift;
  shiftChange: ApprovalChangeShift;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VacationExpandItem',
  props: {
    dat: null,
    approvals: null,
    shift: null,
    shiftPre: null,
    shiftChange: null
  },
  setup(__props: any) {

const vacationKbn = [
  { text: "有給", value: EnumWorkClassification.PAID_HOLIDAY },
  { text: "欠勤", value: EnumWorkClassification.ABSENCE_DAY },
  { text: "特別休暇", value: EnumWorkClassification.SPECIAL_HOLIDAY },
  { text: "その他", value: EnumWorkClassification.OTHER }
];

const ReasonKbn = {
  self: "1",
  ceremonial: "2",
  special: "3"
} as const;

const reasonKbn = [
  { text: "私用", value: ReasonKbn.self },
  { text: "慶弔", value: ReasonKbn.ceremonial },
  { text: "特別", value: ReasonKbn.special }
];

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "早朝休憩時間： ", value: "morningBreakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" },
  { text: "OPE時間： ", value: "opeTime" }
] as const;

const preShiftHeader = [
  { text: "シフト名： ", value: "preShiftName" },
  { text: "シフト開始時間： ", value: "preStartTime" },
  { text: "シフト終了時間： ", value: "preEndTime" },
  { text: "シフト総休憩時間： ", value: "preBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "preMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "preMidnightBreakTime" },
  { text: "シフトOPE時間： ", value: "preOpeTime" }
] as const;

const changeShiftHeader = [
  { text: "シフト名： ", value: "changeShiftName" },
  { text: "シフト開始時間： ", value: "changeStartTime" },
  { text: "シフト終了時間： ", value: "changeEndTime" },
  { text: "シフト総休憩時間： ", value: "changeBreakTime" },
  { text: "シフト早朝休憩時間： ", value: "changeMorningBreakTime" },
  { text: "シフト深夜休憩時間： ", value: "changeMidnightBreakTime" },
  { text: "シフトOPE時間： ", value: "changeOpeTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date?: string | null) => {
  return date
    ? DateTime.fromISO(date)
        .setLocale("ja")
        .toFormat("yyyy年MM月dd日(EEE)")
    : "";
};

const formatDateTime = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};



const displayStatus = (item: any) => {
  let val = "";
  if (item.aid != "" && item.aid != undefined) val = "勤務時間";
  if (item.oid != "" && item.oid != undefined) {
    if (val != "") val = val + ",";
    val = val + "残業";
  }
  if (item.sid != "" && item.sid != undefined) {
    if (val != "") val = val + ",";
    val = val + "シフト";
  }
  if (item.vid != "" && item.vid != undefined) {
    if (val != "") val = val + ",";
    val = val + "休暇";
  }
  if (item.eid != "" && item.eid != undefined) {
    if (val != "") val = val + ",";
    val = val + "早出";
  }
  if (val != "") val = "申請 : " + val + "申請";
  return val;
};

return { __sfc: true,vacationKbn, ReasonKbn, reasonKbn, shiftHeader, preShiftHeader, changeShiftHeader, approvalHeaders, formatDate, formatDateTime, displayStatus, ApprovalChip, TimeList }
}

})